import * as XLSX from "xlsx";
//.........................object to form data................................
export const objectToFormData = (data) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        formData.append(key, item);
      });
    } else {
      formData.append(key, value);
    }
  }

  return formData;
};

//.........................json to xlsx................................
export const jsonToXLSX = (allSheetData) => {
  const wb = XLSX.utils.book_new();

  Object.entries(allSheetData).forEach(([sheetName, data]) => {
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  });

  // Generate binary workbook as Blob
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  return new Blob([wbout], { type: "application/octet-stream" });
};

//.........................object to array................................
export const objectsToArrays = (objArray, keys) => {
  if (!Array.isArray(objArray) || objArray.length === 0) return [];

  const headers = keys || Object.keys(objArray[0]);
  const data = objArray.map((obj) => headers.map((key) => obj[key]));

  return [headers, ...data];
};

//.........................arrays to object................................
export const arraysToObjects = (arrayData, extra={}) => {
  if (!Array.isArray(arrayData) || !Array.isArray(arrayData[0])) return [];
  const headers = arrayData[0];
  const rows = arrayData.slice(1);
  return rows.map((row) =>
    headers.reduce((obj, key, index) => {
      obj[key] = row[index];
      return obj;
    }, { ...extra })
  );
};

// ...................download blob as File.....................................
export const downloadBlobAsFile = (blobData, filename) => {
  const url = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename || "downloaded_file");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// ...................download url as File.....................................
export const downloadUrlAsFile = (url, filename) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
